module.exports = __webpack_public_path__ + "img/logo-header.fbe28632.png";